<template>
  <div
    class="w-fit bg-surface-primary rounded-md p-16 radio-group-item"
    :class="
      selectedRadio == value
        ? 'shadow-buttonBlue border-2 border-solid border-border-secondary'
        : ''
    "
  >
    <input
      :id="id"
      v-model="selectedRadio"
      type="radio"
      :class="inputClass"
      tabindex="0"
      :name="groupName"
      :value="value"
      @change="handleChange"
    />
    <label :for="id" :class="labelClass">
      <span class="flex flex-col items-start justify-center">
        <span>{{ label }}</span>
      </span>
      <span><slot></slot></span>
    </label>
  </div>
</template>

<script lang="ts" setup>
const id = useId();
interface Props {
  label?: string;
  value?: string;
  groupName?: string;
}

const props = withDefaults(defineProps<Props>(), {
  label: '',
  value: '',
  groupName: 'radioknappar',
});

const selectedRadio = defineModel<string>();
const { handleChange } = useField(toRef(props, 'groupName'), {});

const inputClass = `
  appearance-none
  overflow-hidden
  absolute
  peer
  `;

const labelClass = `
  relative
  cursor-pointer
  flex
  flex-wrap
  items-center
  gap-12
  w-fit
  text-16-22
  md:text-18-22
  lg:text-20-24

  before:border-grey-500
  before:border-solid
  before:border-2
  before:h-28
  before:w-28
  before:rounded-full
  before:shadow-grey-500
  before:shadow-[inset_1px_1px_0_1px]
  before:hover:bg-blue-200
  before:hover:transition-all
  before:hover:duration-200
  before:hover:ease-in
  before:peer-checked:bg-green-500

  after:absolute
  after:w-16
  after:h-16
  after:rounded-full
  after:top-7
  after:left-7
  after:peer-checked:bg-grey-500
  after:peer-checked:hover:w-6
  after:peer-checked:hover:h-6
  after:peer-checked:hover:top-12
  after:peer-checked:hover:left-12
  `;
</script>

<style scoped lang="scss">
.radio-group-item:focus-within {
  @apply outline outline-2 outline-border-highlight outline-offset-input;
}
</style>
